@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css");

/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

:host {
  display: block;
}

a,
a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
}


.img-rounded-border {
  border: 10px solid red;
  border-radius: 10px;
}

#about-image {
  /* width: 250px; */
  margin-top: 20px;
}

::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3;
}


.grid-container {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-column-gap: 1px;
   background-color: #ffffff;
 
}


img {
  width: 100%;
  height: 100%;
  object-fit: cover;

}

.item0 {
  height: 300px;
  grid-row-start: 1;
  grid-row-end: 3;
}

.item1 {
  height: 150px;
}

.item2 {
  height: 150px;
}

.item3 {
  height: 150px;
}

.item4 {
  height: 150px;
}


@media only screen and (max-width: 600px) {
  .grid-container {
      grid-template-columns: auto;
  }

}

.image-first {
  margin: 0;
  position: relative;
  height: 300px;
}

.image-rest {
  margin: 0;
  position: relative;
  height: 150px;
}

.bottom-left h3 {
  position: absolute;
  color: white;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  bottom: 0;
  width:100%;
  padding: 10px;
  margin: 0;
}
